export const SCROLL_TO_CLASS = 'raOptimal/scrolling/transition/scrollToClass';
export const SCROLL_TO_ID = 'raOptimal/scrolling/transition/scrollToId';
export const RESET_SCROLL = 'raOptimal/scrolling/transition/resetScroll';

export const transitionScrolling = {
    scrollToClass: (value) => ({type: SCROLL_TO_CLASS, value}),
    scrollToId: (value) => ({type: SCROLL_TO_ID, value}),
}

export const resetScroll = () => ({ type: RESET_SCROLL });